
import Header from "@/components/Header";
import { FamilyInformationCard } from "@/components/statistics/FamilyInformationCard";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { TimeRangeSelector } from "@/components/statistics/TimeRangeSelector";
import { GrowthTabs } from "@/components/statistics/GrowthTabs";
import { SignInPrompt } from "@/components/statistics/SignInPrompt";
import { LoadingSpinner } from "@/components/statistics/LoadingSpinner";
import { useStatisticsData } from "@/hooks/useStatisticsData";

const Statistics = () => {
  const { language } = useLanguage();
  const {
    user,
    isLoading,
    timeRange,
    setTimeRange,
    heightData,
    weightData,
    displayOriginalHeight,
    displayOriginalWeight,
    useMetricHeight,
    useMetricWeight,
    handleHeightUnitToggle,
    handleWeightUnitToggle,
    refreshProfiles,
    babyAgeInMonths
  } = useStatisticsData();
  
  return (
    <main className="min-h-screen pt-24 pb-16">
      <Header />
      <div className="container max-w-6xl mx-auto px-4">
        <div className="flex flex-col mb-8 animate-fade-down">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">{t('statistics.title', language)}</h1>
              <p className="text-muted-foreground mt-1">
                {t('statistics.subtitle', language)}
              </p>
            </div>
          </div>
          
          {!user ? (
            <SignInPrompt />
          ) : (
            <FamilyInformationCard onProfileUpdate={refreshProfiles} />
          )}
          
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className="flex justify-between mb-4">
                <TimeRangeSelector
                  timeRange={timeRange}
                  setTimeRange={setTimeRange}
                />
              </div>
              
              <GrowthTabs
                heightData={heightData}
                weightData={weightData}
                displayOriginalHeight={displayOriginalHeight}
                displayOriginalWeight={displayOriginalWeight}
                useMetricHeight={useMetricHeight}
                useMetricWeight={useMetricWeight}
                handleHeightUnitToggle={handleHeightUnitToggle}
                handleWeightUnitToggle={handleWeightUnitToggle}
                babyAgeInMonths={babyAgeInMonths}
              />
            </>
          )}
        </div>
      </div>
    </main>
  );
};

export default Statistics;

